module.exports = __webpack_public_path__ + "img/project-16.8b9105f1.png";